import { render } from "./chat-right-image.vue?vue&type=template&id=7ade6f9a"
import script from "./chat-right-image.vue?vue&type=script&lang=js"
export * from "./chat-right-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__